import { TRANSMITTAL_ITEM_REVISION_COLUMN_WIDTH } from '@common/constants';
import { isPositiveNumber } from '@core/Primitives/number.services';
import { DownloadFile } from '@file/DownloadFile';
import { Column, createTableCell, Icon, TableCellExtras, TableRowExtras, Tooltip } from '@gcl/react-core';
import React from 'react';

export const createTransmittalItemDownloadColumn = <D extends object>(
  accessor: string,
  header: string,
  handleItem: (
    value: string,
    item: D,
    index: number,
    cellExtras: TableCellExtras,
    rowExtras: TableRowExtras,
  ) => {
    projectFileId?: number | undefined;
    projectId?: number | undefined;
    displayText?: string | undefined;
    defaultElement?: React.ReactElement | undefined;
  },
  disableSortBy = false,
  className = '',
) => {
  return {
    accessor,
    Header: header,
    disableResizing: true,
    disableSortBy,
    width: TRANSMITTAL_ITEM_REVISION_COLUMN_WIDTH,
    maxWidth: TRANSMITTAL_ITEM_REVISION_COLUMN_WIDTH,
    minWidth: TRANSMITTAL_ITEM_REVISION_COLUMN_WIDTH,
    Cell: createTableCell<string, D>(
      (value: string, item: D, index: number, cellExtras: TableCellExtras, rowExtras: TableRowExtras) => {
        const { projectFileId, displayText, projectId, defaultElement } = handleItem(
          value,
          item,
          index,
          cellExtras,
          rowExtras,
        );

        return (
          <div className={className || ''}>
            {!isPositiveNumber(projectFileId) ? (
              <>
                {defaultElement || (
                  <Tooltip overlay="Not issued">
                    <Icon iconName="DashCircle" className="gcl-gems-transmittal-item-download-column-not-issued-icon" />
                  </Tooltip>
                )}
              </>
            ) : (
              <DownloadFile
                shouldNotChop
                text={displayText || value}
                projectId={projectId || 0}
                attachmentId={projectFileId || 0}
              />
            )}
          </div>
        );
      },
    ),
  } as Column;
};
